module.exports = __webpack_public_path__ + "img/neotag-product1.63eba8f8.jpg";